import React, { useEffect, useRef } from 'react';

const InactivityCheck = ({ children }) => {
  const timeoutRef = useRef(null);

  // Set inactivity timeout to 30 minutes (adjust if necessary)
  const INACTIVITY_TIMEOUT = 30 * 60 * 1000;

  const handleLogout = () => {
    // Clear auth data and redirect to login
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    sessionStorage.clear();
    
    // Using window.location to ensure a full refresh and redirect
    window.location.href = '/';
  };

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(handleLogout, INACTIVITY_TIMEOUT);
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'mousedown', 'scroll', 'touchstart'];

    events.forEach(event => {
      window.addEventListener(event, resetTimeout);
    });

    resetTimeout();

    return () => {
      events.forEach(event => {
        window.removeEventListener(event, resetTimeout);
      });
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return <>{children}</>;
};

export default InactivityCheck;
